import { timestampFromDate } from '@bufbuild/protobuf/wkt';
import { Client } from '@connectrpc/connect';

import { AuditlogService } from './espb/auditlog_service_pb';
import EspbServiceClientFactory from './EspbServiceClientFactory';
import { requireFieldNotEmpty } from './grpcUtils';
import { ClientType, EventId } from './types';

export default class AuditlogWriteClient {
  private readonly espbClient: Client<typeof AuditlogService>;

  constructor(
    public readonly baseUri: string,
    public readonly authToken: string,
    public readonly clientType: ClientType,
    public readonly clientId?: string,
    public readonly clientVersion?: string,
  ) {
    const factory = new EspbServiceClientFactory({
      authTokens: {
        auditlogWrite: authToken,
      },
      clientId,
      clientType,
      clientVersion,
      baseUri,
      syncSuperUsers: false,
    });
    this.espbClient = factory.createServiceClient(AuditlogService);
  }

  async writeEvents(
    eventData: Array<{ clientTime: Date; lastKnownServerTime: Date; event: object }>,
  ): Promise<EventId[]> {
    const resp = await this.espbClient.writeEvents({
      events: eventData.map(({ clientTime, lastKnownServerTime, event }) => ({
        eventJson: JSON.stringify(event),
        lastKnownServerTime: timestampFromDate(lastKnownServerTime),
        clientTime: timestampFromDate(clientTime),
      })),
    });
    return requireFieldNotEmpty(resp.eventIds);
  }
}
